import { Tag } from '@televet/kibble-ui/build/components/Tag';
import React, { useMemo } from 'react';
import { EmailCampaignStatus } from 'shared/types/graphql';

type CampaignStatusTagProps = {
  status: EmailCampaignStatus;
  big?: boolean;
};

const CampaignStatusTag = ({ status, big }: CampaignStatusTagProps): JSX.Element => {
  const variant = useMemo(() => {
    switch (status) {
      case EmailCampaignStatus.Draft:
        return 'background.warning';
      case EmailCampaignStatus.Sending:
        return 'background.success';
      case EmailCampaignStatus.Sent:
        return 'background.success';
      default:
        return 'background.subtle';
    }
  }, [status]);

  return <Tag size={big ? 'md' : 'sm'} label={status} bg={variant} />;
};

export default CampaignStatusTag;
